import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, MapPinIcon, GlobeIcon, MessageCircleIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface HelpCenterProps {
  navigate: (screen: string) => void;
}
export function HelpCenter({
  navigate
}: HelpCenterProps) {
  const contactMethods = [{
    icon: PhoneIcon,
    title: 'Call Us',
    desc: 'Mon-Fri from 8am to 5pm',
    value: '+234 800 000 0000',
    action: 'tel:+2348000000000',
    color: 'text-blue-600',
    bg: 'bg-blue-50'
  }, {
    icon: MailIcon,
    title: 'Email Us',
    desc: 'We usually respond within 24 hours',
    value: 'support@skydd.com',
    action: 'mailto:support@skydd.com',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50'
  }, {
    icon: MessageCircleIcon,
    title: 'Live Chat',
    desc: 'Chat with our support team',
    value: 'Start a conversation',
    action: () => navigate('live-chat'),
    color: 'text-amber-600',
    bg: 'bg-amber-50'
  }];
  return <div className="flex-1 bg-slate-50 flex flex-col h-full overflow-y-auto pb-safe" data-id="element-2103">
      <TopBar title="Help Center" showBack onBack={() => navigate('profile')} data-id="element-2104" />

      <div className="px-5 pt-6 pb-8" data-id="element-2105">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-8" data-id="element-2106">
          <div className="w-16 h-16 bg-[#0D3B3B]/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2107">
            <GlobeIcon className="w-8 h-8 text-[#0D3B3B]" data-id="element-2108" />
          </div>
          <h2 className="text-2xl font-black text-[#0D3B3B] mb-2" data-id="element-2109">
            How can we help?
          </h2>
          <p className="text-gray-500 text-sm" data-id="element-2110">
            Choose a way to reach out to our support team.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-2111">
          {contactMethods.map((method, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} data-id="element-2112">
              {typeof method.action === 'string' ? <a href={method.action} className="block bg-white p-5 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-2113">
                  <div className="flex items-start gap-4" data-id="element-2114">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${method.bg}`} data-id="element-2115">
                      <method.icon className={`w-6 h-6 ${method.color}`} data-id="element-2116" />
                    </div>
                    <div data-id="element-2117">
                      <h3 className="font-bold text-[#0D3B3B]" data-id="element-2118">
                        {method.title}
                      </h3>
                      <p className="text-xs text-gray-500 mb-1" data-id="element-2119">
                        {method.desc}
                      </p>
                      <p className="text-sm font-semibold text-[#0D3B3B]" data-id="element-2120">
                        {method.value}
                      </p>
                    </div>
                  </div>
                </a> : <button onClick={method.action} className="w-full text-left bg-white p-5 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-2121">
                  <div className="flex items-start gap-4" data-id="element-2122">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${method.bg}`} data-id="element-2123">
                      <method.icon className={`w-6 h-6 ${method.color}`} data-id="element-2124" />
                    </div>
                    <div data-id="element-2125">
                      <h3 className="font-bold text-[#0D3B3B]" data-id="element-2126">
                        {method.title}
                      </h3>
                      <p className="text-xs text-gray-500 mb-1" data-id="element-2127">
                        {method.desc}
                      </p>
                      <p className="text-sm font-semibold text-[#0D3B3B]" data-id="element-2128">
                        {method.value}
                      </p>
                    </div>
                  </div>
                </button>}
            </motion.div>)}

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="bg-white p-5 rounded-2xl border border-gray-100 shadow-sm mt-6" data-id="element-2129">
            <div className="flex items-start gap-4" data-id="element-2130">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 bg-gray-50" data-id="element-2131">
                <MapPinIcon className="w-6 h-6 text-gray-600" data-id="element-2132" />
              </div>
              <div data-id="element-2133">
                <h3 className="font-bold text-[#0D3B3B] mb-1" data-id="element-2134">Head Office</h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-2135">
                  123 Business Avenue,
                  <br data-id="element-2136" />
                  Victoria Island,
                  <br data-id="element-2137" />
                  Lagos, Nigeria
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}